import ACTIONS from "../../constatnts"

export const getImgs = payload => ({
  type: ACTIONS.GET_IMGS_LIB,
  payload,
})
